import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {

  const isAuth = sessionStorage.getItem("adminAuth");

  if (isAuth !== "true") {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
}